<template>
  <component
    :is="tag"
    class="gradient-border__wrapper"
    :class="wrapperDynamicClass"
  >
    <slot />
  </component>
</template>

<script>
import { PROP_TYPES, propValidator } from '@fmpedia/validators'
import { HTML_TAG } from '@fmpedia/enums'

export default {
  name: 'AGradientBorder',
  props: {
    tag: propValidator([PROP_TYPES.STRING], false, HTML_TAG.DIV),
    withTransitionOnHover: propValidator([PROP_TYPES.BOOLEAN], false, false)
  },
  computed: {
    wrapperDynamicClass() {
      return {
        hoverable: this.withTransitionOnHover
      }
    }
  }
}
</script>

<style lang="scss">
.gradient-border__wrapper {
  // "Border" width
  padding: 1px;
  position: relative;

  background: linear-gradient(to bottom, #acaeb7cc, #4c4d51cc);

  & > * {
    position: relative;
    border-radius: inherit;
    width: 100%;
    height: 100%;
    background-color: $c--black;
    z-index: 1;
  }

  /** 
   * Since gradient background doesn't support transition, we mimic it
   * by using opacity 
   */
  &.hoverable {
    &:before {
      opacity: 0;
      position: absolute;
      content: '';
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: linear-gradient(to top, #acaeb7, #4c4d51);
      transition: opacity 0.3s linear;
      border-radius: inherit;
    }

    &:hover:before {
      opacity: 1;
    }
  }
}
</style>
